'use client'

import { useTranslations } from 'next-intl'
import { Tag } from '@eversports/klimt-primitives/Tag'

import { LimitedSpots, UnlimitedSpots } from '../../../../../../../../App.types'
import { RegistrationState, EventRegistrationValidationProblem } from '../../ActivityCard.types'

interface Props {
  registrationState: RegistrationState
  availableSpots: Omit<LimitedSpots, 'type'> | Omit<UnlimitedSpots, 'type'>
}

const RegistrationStateBadges = ({ registrationState, availableSpots }: Props) => {
  const t = useTranslations('discover-sport-city')

  const { bookable, validationProblems } = registrationState
  const { __typename } = availableSpots

  const hasBooked = !bookable && validationProblems.includes(EventRegistrationValidationProblem.ALREADY_REGISTERED)
  const isSoldOut = !bookable && validationProblems.includes(EventRegistrationValidationProblem.FULLY_BOOKED)

  const showBookingUrgency = __typename === 'LimitedSpots' && availableSpots.limit > 0 && !availableSpots.displayCapped
  const spotsLeft = __typename === 'LimitedSpots' && availableSpots.limit

  if (!hasBooked && !isSoldOut && !showBookingUrgency) {
    return null
  }

  return (
    <>
      {hasBooked && <Tag variant="primary" style="outline" text={t('registration-state-already-registered')} />}
      {showBookingUrgency && spotsLeft && (
        <Tag variant="tertiary" style="outline" text={t('registration-state-spots-left', { count: spotsLeft })} />
      )}
      {isSoldOut && <Tag variant="warning" style="outline" text={t('registration-state-spots-left', { count: 0 })} />}
    </>
  )
}

export default RegistrationStateBadges
